module.exports = __webpack_public_path__ + "media/img/frontend_application/content_production/top_service_two-c133c456e9a084275299dc5f78c69ff6.png";